import { useUpdateTodoSortModeMutation } from 'shared/hooks/queries/use-update-todo-sort-mode-mutation';

export const useUpdateTodoSortMode = () => {
  const { mutate } = useUpdateTodoSortModeMutation();

  return mutate;
};
